const es = {
    "project.global.fields.email": "Email",
    "project.global.fields.password": "Contraseña",
    'project.app.Header.quiz': 'Quiz',
    'project.global.fields.points': 'Puntos',
    'project.app.Header.Awards': 'Recompensas',
    'project.users.MyAwards.title': 'Mis Recompensas',
    'project.entities.AwardDetails.Points': 'Puntos requeridos: ',
    'project.entities.AwardDetails.Button': 'Canjear Premio',
    'project.app.Header.historic': 'Historico',
    'project.modules.historic.podiums': 'Podios',
    'project.entities.PodiumDetails.date':'Fecha',
    'project.entities.PodiumDetails.winner': 'Ganador',
    'project.entities.PodiumDetails.TeamWinner':'Equipo ganador',
    'project.entities.PodiumDetails.second': 'Segundo Puesto',
    'project.entities.PodiumDetails.third':'Tercer Puesto',
    'project.entities.Circuits': 'Circuitos F1',
    'project.entities.Podiums': 'Podios',
    "project.events.events": 'Eventos',
    'project.events.events.create': 'Crear Evento',
    'project.common.notifications.button': 'Notificaciones',
    'project.users.SignUp.fields.confirmPassword': 'Confirmar Contraseña',
    'project.global.fields.event.name': 'Nombre Evento',
    'project.global.fields.event.description': 'Descripción',
    'project.global.fields.events.location' : 'Localización',
    'project.global.fields.events.date' : 'Fecha Evento',
    'project.global.buttons.save': 'Guardar',
    'project.global.buttons.UpdateProfile': 'Actualizar Perfil',
    'project.global.buttons.back': 'Anterior',
    'project.global.buttons.continue': 'Continuar',
    'project.global.buttons.filter': 'Filtrar',
    'project.global.buttons.next': 'Siguiente',
    'project.users.SignUp.title': 'Registrarse',
    'project.global.fields.firstName': 'Nombre',
    'project.global.fields.lastName': 'Apellido',
    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirmar nueva contraseña',
    'project.users.ChangePassword.fields.newPassword': 'Nueva Contraseña',
    'project.users.ChangePassword.fields.oldPassword': 'Antigua Contraseña',
    'project.users.ChangePassword.title': 'Cambiar contraseña',
    'project.users.UpdateProfileImage.title':'Añadir Imagen',
    'project.user.userImage.title': 'Añadir tu imagen de usuario',
    'project.global.fields.title': 'Titulo',
    'project.global.fields.url': 'URL',
    'project.global.fields.userName': 'Nombre usuario',
    'project.users.Profile.title': 'Titulo',
    'project.users.CreatePost.title': 'Crear Publicación',
    'project.users.MyPosts.title': 'Mis Publicaciones',
    'project.app.Header.calendar': 'Calendario',
    'project.events.events': 'Eventos',
    'project.app.Header.login': 'Iniciar Sesión',
    'project.app.Header.logout': 'Salir',
    'project.Footer': 'Overcut',
    'project.entities.EventDetails.name': 'Evento',
    'project.entities.EventDetails.description': 'Descripción',
    'project.entities.EventDetails.location': 'Localización',
    'project.entities.EventDetails.date': 'Fecha',
    'project.entities.EventDetails.image':'Imagen',
    'project.entities.EventDetails.button': 'Crear Notificación',
    'project.entities.Events': 'Eventos',
    'project.global.dropdown.sortOrderDES': 'Orden des',
    'project.global.dropdown.sortOrderDefault': 'Orden por Defecto',
    'project.global.dropdown.sortOrderASC': 'Orden asc',
    'project.global.dropdown.allCategories': 'Todas las categorías',
    'project.global.dropdown.sortCriteriaAll': 'Todos',
    'project.global.dropdown.sortCriteriaCreationDate': 'Fecha Creación',
    'project.users.CreateEvent.title': 'Crear Evento',
    'project.About_Us': 'About Us',
    'project.Contact': 'Contact',
    'project.modules.historic.stats': 'Estadísticas',
    'project.global.fields.subtitle': 'Subtitulo',
    'project.global.fields.article': 'Artículo',
    'project.global.fields.category': 'Categoría',
    'project.posts.CreatePost.title': 'Crear publicación',
    'project.user.postImage.title': 'Titulo Imagen',
    'project.global.post.addImageCreatePost': 'Añadir Imagen',
    'project.entities.User.Points': 'Puntos usuario: ',
    'project.entities.Quiz.Answers': 'La respuesta correcta es: ',
    'project.entities.stats.circuit': 'Datos de las ultimas 10 temporadas',
    'project.entities.stats.teams.wins': 'Total de victorias de equipos en las ultimas 10 temporadas',
    'project.entities.stats.drivers.podiums': 'Pilotos con mas podios en F1',
    'project.entities.stats.drivers.wins': 'Pilotos con mas victorias en F1',
    'project.entities.stats.drivers.championships': 'Pilotos con mas campeonatos de F1',
    'project.entities.EventDetails.button.delete': 'Borrar Evento',
    'project.entities.SignUp.Journalist': 'Soy periodista',
    'project.no_awards': 'No hay recompensas disponibles',
    'project.entities.Awards.User.Points': 'No tiene los puntos suficientes',
    'project.global.post.modifyPost': 'Modificar Post',
    'project.global.fields.modifytitle': 'Titulo',
    'project.global.fields.modifysubtitle': 'Subtitulo',
    'project.global.fields.modifyarticle': 'Articulo',
    'project.global.fields.modifycategory': 'Categoria',
    'project.entities.Post.Modify': 'Modificar Post',
    'project.entities.Post.Delete': 'Eliminar Post',
    'project.entities.Posts.MyPosts': 'Mis Posts',
    'project.entities.Quiz.getPoints': 'Has obtenido ',
    'project.points': 'puntos',
    'project.YourPoints': 'Tu puntaje',
    'project.Circuit.Details.Name': 'Circuito: ',
    'project.Circuit.Details.Distance': 'Distancia: ',
    'project.Circuit.Details.Laps': 'Vueltas: ',
    'project.Circuit.Details.Image': 'Imagen: ',
    'project.Circuit.Details.Team': 'Equipo más exitoso: ',
    'project.entities.Quiz.Result.Points': 'Puntuación disponible: ',
    'project.entities.Quiz.Result.QuizPoints': 'Puntos conseguidos: ',
    'project.entities.Quiz.Result.Questions': 'Total preguntas: ',
    'project.entities.Quiz.Result.ButtonHome': 'Volver al inicio',
    'project.entities.Quiz.Result.Excellent': 'Excelente! Conseguiste más de la mitad de los puntos disponibles',
    'project.entities.Quiz.Result.Retry': 'Inténtalo mejor la próxima vez',
    'project.entities.Quiz.Result': 'Resultados',
    'project.entities.Award.Result.Achieved': '¡Enhorabuena! ¡Has canjeado la recompensa!',
    'project.entities.Award.Result.ButtonHome': 'Ir a mi lista de recompensas canjeadas',
    'project.app.Header.minigames': 'OverCutGames',
    'crossword.title': 'Crucigrama',
    'crossword.subtitle': 'Rellena todas las palabras y demuestra que conoces la historia de la F1',
    'crossword.reset': 'Reiniciar crucigrama',
    'crossword.clues.horizontal': 'Pistas Horizontales',
    'crossword.clues.vertical': 'Pistas Verticales',
    'crossword.validate': 'Validar palabra',
    'quiz.loading': 'Preparando la parrilla de salida...',
    'quiz.intro.title': 'Bienvenido al OverCut Quiz',
    'quiz.intro.subtitle': 'Demuestra tu conocimiento sobre Fórmula 1',
    'quiz.intro.play': 'Jugar ahora',
    'quiz.result.title': '¡Carrera terminada!',
    'quiz.result.subtitle': '¡Gracias por participar en este quiz de OverCut!',
    'quiz.result.points': '🏁 Puntos:',
    'quiz.result.total': 'Total conseguido:',
    'quiz.result.point': 'puntos',
    'quiz.result.back': 'Volver al inicio',
    'project.users.CreateJournalist.title': 'Registrar Periodista',
    'project.app.Header.ranking': 'Ranking',
    'project.users.EmailConfirmationPending.title': '¡Registro completado!',
    'project.users.EmailConfirmationPending.message': 'Revisa tu correo electrónico y activa tu cuenta desde el enlace recibido para poder iniciar sesión. La recepción del correo tarda unos 5 minutos aproximadamente. Si no se encuentra en la bandeja de entrada revisa el correo no deseado.',
    'project.users.Login.title': 'Iniciar sesión',
    'project.users.Login.rememberMe': 'Recuérdame',
    'project.global.buttons.login': 'Iniciar sesión',
    'project.users.Login.signUpPrompt': '¿No tienes una cuenta? Regístrate',
    'project.users.UpdateProfile.title': 'Actualizar Perfil',
    'project.user.addImage': 'Añadir Imagen',
    'project.exceptions.IncorrectLoginException': 'Inicio sesión incorrecto',
    "validation.password.length": "Al menos 8 caracteres",
    "validation.password.uppercase": "Al menos una mayúscula",
    "validation.password.number": "Al menos un número",
    "validation.password.special": "Al menos un carácter especial",
    "project.global.validator.passwordsDoNotMatch": "Contraseña no válida",
    "project.emailVerification.loading": "Verificando tu cuenta...",
    "project.emailVerification.success": "¡Tu cuenta ha sido activada correctamente!",
    "project.emailVerification.loginButton": "Iniciar sesión",
    "project.emailVerification.invalidOrExpired": "Enlace de verificación no válido o expirado",
    "project.emailVerification.goBack": "Volver a la página principal",
    "project.global.errors.title": "Contraseña antigua incorrecta",
    'project.users.confirmPasswordChange.success': '✅ Contraseña actualizada correctamente',
    'project.users.confirmPasswordChange.error': '❌ Token inválido o expirado',
    'project.global.buttons.backHome': 'Volver al inicio',
    'project.users.passwordChangeRequested': 'Hemos enviado un correo de confirmación para aplicar el cambio de contraseña.',
    "project.app.Header.f1hub": "OverCutHub",
    "postEditor.newPost": "Nuevo Post",
    "postEditor.title": "Título",
    "postEditor.subtitle": "Subtítulo",
    "postEditor.category": "Categoría",
    "postEditor.mainImage": "Imagen principal del post",
    "postEditor.addSection": "Añadir subsección",
    "postEditor.section": "Sección",
    "postEditor.sectionTitle": "Título de sección",
    "postEditor.addText": "+ Texto",
    "postEditor.addImage": "+ Imagen",
    "postEditor.addTweet": "+ Tweet",
    "postEditor.textBlock": "Texto",
    "postEditor.tweetBlock": "URL del tweet",
    "postEditor.publish": "Publicar post",
    "post.caption.image": "Pie de foto:",
    "post.caption.tweet": "Comentario sobre el tweet:",
    "postEditor.mainImageCaption": "Pie de imagen principal",
    "post.caption.mainImage": "Pie:",
    "project.app.Header.about": "¿Qué es OverCut?",
    "project.global.buttons.pleaseWait": "Espere por favor...",
    "project.About": "Sobre OverCut",
    "project.LegalNotice": "Aviso legal",
    "project.TermsOfUse": "Condiciones de uso",
    "project.PrivacyPolicy": "Política de privacidad",
    "project.CookiesPolicy": "Política de cookies",
    "project.ContactEmail": "Contacto:",
    "project.AllRightsReserved": "Todos los derechos reservados.",
    "project.IntellectualProperty": "Propiedad Intelectual",
    "project.LegalPolicies": "Políticas legales",
    "project.LegalPoliciesSubtitle": "Consulta todos nuestros documentos legales en un solo lugar.",
    "project.ReadMore": "Ver más",
     "project.LegalNoticeDesc": "Titularidad, contacto e información general.",
     "project.TermsOfUseDesc": "Normas de uso de OverCut.",
     "project.PrivacyPolicyDesc": "Tratamiento de datos y tus derechos.",
     "project.IntellectualPropertyDesc": "Propiedad intelectual y usos permitidos.",
     "project.CookiesPolicyDesc": "Cookies utilizadas y configuración.",
"project.users.Login.forgotPassword": '¿Olvidaste tu contraseña?',
"project.users.requestPasswordReset.title": 'Restablecer contraseña',
"project.users.requestPasswordReset.send": 'Enviar email',
"project.users.passwordResetRequested": 'Si el email existe, hemos enviado un correo con el enlace para restablecerla. La recepción del correo puede tardar unos 5 minutos.',
"project.users.passwordReset.title": 'Nueva contraseña',
"project.users.passwordReset.success": 'Tu contraseña se ha restablecido correctamente',
"project.users.passwordReset.error": 'El enlace no es válido o ha expirado'

}
export default es;
